export default "__VITE_ASSET__cbbd7da6__"